import { render, staticRenderFns } from "./camper.vue?vue&type=template&id=2c984b0e&scoped=true&"
import script from "./camper.vue?vue&type=script&lang=js&"
export * from "./camper.vue?vue&type=script&lang=js&"
import style0 from "./camper.vue?vue&type=style&index=0&id=2c984b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c984b0e",
  null
  
)

export default component.exports